{
  "listingTableConfig": {
    "name": "Invoice",
    "columns": [
      {
        "fieldName": "invoiceNo",
        "displayName": "Invoice Number",
        "dataType": "CLICKABLE",
        "thStyleConfig": {
          "width": "150px"
        },
        "styleConfig": {
          "type": "hyper-link"
        }
      },
      {
        "fieldName": "customer.name",
        "displayName": "Customer Name",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "350px"
        }
      },
      {
        "fieldName": "invoiceDate",
        "displayName": "Billing Date",
        "dataType": "DATETIME",
        "thStyleConfig": {
          "width": "120px"
        }
      },
      {
        "fieldName": "dueDate",
        "displayName": "Valid Till",
        "dataType": "DATETIME",
        "thStyleConfig": {
          "width": "120px"
        }
      },
      {
        "fieldName": "status",
        "displayName": "Status",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "150px"
        },
        "valueMap": {
          "PAID": "Paid",
          "PENDING": "Pending",
          "OVERDUE": "Overdue",
          "PARTIALLY_PAID": "Partially Paid",
          "CREATED": "Invoice Generated",
          "IRN_ERROR": "Invoice Error"
        },
        "styleConfig": {
          "type": "badge",
          "styleProperties": {
            "display": "flex",
            "padding": "2px 8px 2px 6px",
            "align-items": "center",
            "gap": "4px",
            "border-radius": "16px",
            "text-align": "center",
            "font-size": "12px",
            "font-style": "normal",
            "font-weight": "500",
            "line-height": "18px",
            "width": "fit-content"
          },
          "conditions": [
            {
              "expression": "eq(value, 'PAID')",
              "icon": "assets/icons/green_Dot.svg",
              "iconPosition": "left",
              "iconStyleProperties": {
                "width": "8px",
                "height": "8px",
                "background": "#17B26A"
              },
              "styleProperties": {
                "border": "1px solid var(--Success-200, #ABEFC6)",
                "background": "var(--Success-50, #ECFDF3)",
                "color": "var(--Success-700, #067647)"
              }
            },
            {
              "expression": "eq(value, 'PENDING')",
              "icon": "assets/icons/red_Dot.svg",
              "iconPosition": "left",
              "iconStyleProperties": {
                "width": "8px",
                "height": "8px",
                "background": "#F04438"
              },
              "styleProperties": {
                "border": "1px solid var(--Error-200, #FECDCA)",
                "background": "var(--Error-50, #FEF3F2)",
                "color": "var(--Error-700, #B42318)"
              }
            },
            {
              "expression": "eq(value, 'OVERDUE')",
              "icon": "assets/icons/red_Dot.svg",
              "iconPosition": "left",
              "iconStyleProperties": {
                "width": "8px",
                "height": "8px",
                "background": "#F04438"
              },
              "styleProperties": {
                "border": "1px solid var(--Error-200, #FECDCA)",
                "background": "var(--Error-50, #FEF3F2)",
                "color": "var(--Error-700, #B42318)"
              }
            },
            {
              "expression": "eq(value, 'PARTIALLY_PAID')",
              "icon": "assets/icons/red_Dot.svg",
              "iconPosition": "left",
              "iconStyleProperties": {
                "width": "8px",
                "height": "8px",
                "background": "#F38744"
              },
              "styleProperties": {
                "border": "1px solid var(--Orange-200, #F9DBAF)",
                "background": "var(--Orange-50, #FEF6EE)",
                "color": "var(--Warning-600, #DC6803)"
              }
            },
            {
              "expression": "eq(value, 'CREATED')",
              "icon": "assets/icons/red_Dot.svg",
              "iconPosition": "left",
              "iconStyleProperties": {
                "width": "8px",
                "height": "8px",
                "background": "#2E90FA"
              },
              "styleProperties": {
                "border": "1px solid var(--Blue-200, #B2DDFF)",
                "background": "var(--Blue-50, #EFF8FF)",
                "color": "var(--Blue-700, #175CD3)"
              }
            },
            {
              "expression": "eq(value, 'IRN_ERROR')",
              "icon": "assets/icons/red_Dot.svg",
              "iconPosition": "left",
              "iconStyleProperties": {
                "width": "8px",
                "height": "8px",
                "background": "#4E5BA6"
              },
              "styleProperties": {
                "color": "var(--Gray-blue-700, #363F72)",
                "border": "1px solid var(--Gray-blue-200, #D5D9EB)",
                "background": "var(--Gray-blue-50, #F8F9FC)"
              }
            }
          ]
        }
      },

      {
        "fieldName": "amount.totalAmount",
        "displayName": "Total Amount",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "70px"
        },
        "styleConfig": {
          "styleProperties": {
            "color": "var(--Brand-500, #1D7EDA)",
            "fontFamily": "Inter",
            "fontSize": "13px",
            "fontStyle": "normal",
            "fontWeight": "600",
            "lineHeight": "20px"
          }
        }
      },
      {
        "fieldName": "dueAmount",
        "displayName": "Due Amount",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "70px"
        }
      },
      {
        "fieldName": "invoiceType",
        "displayName": "Invoice Type",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "70px"
        }
      },
      {
        "fieldName": "createdDate",
        "dbName": "created_date",
        "displayName": "Created Date",
        "dataType": "DATETIME",
        "thStyleConfig": {
          "width": "120px"
        }
      },
      {
        "fieldName": "modifiedBy",
        "dbName": "modified_by",
        "displayName": "Modified By",
        "dataType": "STRING",
        "styleConfig": {
          "type": "user-avatar"
        }
      }
    ],
    "actions":[
      {
        "fieldName": "irnFailed",
        "displayName": "",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "140px"
        },
        "styleConfig": {
          "type": "action",
          "styleProperties": {
            "background": "#F5F5F4",
            "border": "none",
            "color": "var(--gray-700)",
            "box-shadow": "0px 1px 2px 0px rgba(16, 24, 40, 0.05)"
          },
          "actionConfig": {
            "label": "Error Log",
            "writeOperation": false,
            "actionName":"view-error-log",
            "conditions": [ {
              "expression": "eq(value, true)"
            }
            ]
          }
        }
      },
      {
        "fieldName": "irnFailed",
        "displayName": "",
        "dataType": "STRING",
        "styleConfig": {
          "type": "action",
          "icon": "assets/icons/refresh_icon.svg",
          "iconStyleProperties": {
            "background": "var(--error-600)"
          },
          "styleProperties": {
            "border-radius": "8px",
            "background": "var(--gray-warm-100)",
            "border": "none",
            "box-shadow": "0px 1px 2px 0px rgba(16, 24, 40, 0.05)"
          },
          "actionConfig": {
            "label": "",
            "writeOperation": false,
            "actionName":"generate-irn",
            "conditions": [ {
              "expression": "eq(value, true)"
            }
            ]
          }
        }
      }
    ]
  },
  "filterConfig": [
    {
      "name": "invoiceNo",
      "displayLabel": "Invoice Number",
      "dataType": "STRING",
      "supportedOperators": ["EQ", "CONTAINS"],
      "operatorToFilterMap": {
        "EQ": "INVOICE_NO_EQUALS",
        "CONTAINS": "INVOICE_NO_CONTAINS"
      }
    },
    {
      "name": "customer",
      "displayLabel": "Customer",
      "dataType": "STRING",
      "supportedOperators": ["EQ"],
      "operatorToFilterMap": {
        "EQ": "CUSTOMER_EQUALS"
      },
      "hasLookup": true,
      "searchConfig": {
        "apiUrl": "v1/customers/list",
        "filterByKeys": ["NAME_CONTAINS"],
        "additionalFilters": [
          {
            "name": "IS_ACTIVE",
            "alias": "active",
            "operator": "EQ",
            "value": ["true"]
          }
        ],
        "limit": 10,
        "orderBy": { "name": "asc" },
        "bindLabel": "name",
        "bindValue": "id",
        "displayColumns": [{ "key": "name", "header": "Name" }]
      }
    },
    {
      "name": "status",
      "displayLabel": "Status",
      "dataType": "STRING",
      "supportedOperators": ["EQ"],
      "operatorToFilterMap": {
        "EQ": "STATUS_CONTAINS"
      }
    }
  ]
}
